import { useState } from 'react';
import { InvoiceCreateModal, InvoicePendingModal } from '../../design-system';
import { InvoicesPage, InvoicesHeader, InvoicesBody } from './InvoicesByClientYardComponents';

export const InvoicesByClientYard = () => {
  const [data, setData] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkIndexs, setCheckIndexs] = useState<number[]>([]);

  const handleCheckboxChange = (i: number) => {
    if (isNaN(i)) {
      const allCheckIndexs = Array.from({ length: data.length }, (_, idx) => idx);
      setCheckIndexs(checkIndexs.length === data.length ? [] : allCheckIndexs);
      return;
    }

    setCheckIndexs((prev) =>
      prev.includes(i) ? prev.filter((index) => index !== i) : [...prev, i],
    );
  };

  return (
    <>
      <InvoicesPage id={'invoices-by-client-yard-page'} innerScroll>
        <InvoicesHeader totalCount={totalCount} />
        <InvoicesBody
          setData={setData}
          setTotalCount={setTotalCount}
          checkIndexs={checkIndexs}
          setCheckIndexs={setCheckIndexs}
          handleCheckboxChange={handleCheckboxChange}
        />
      </InvoicesPage>
      <InvoiceCreateModal />
      <InvoicePendingModal />
    </>
  );
};
